
import React from "react";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface FilterTagsProps {
    value: string;
    options: [string, string][];
    onChange: (value: string) => void;
}

function FilterTags({ value, options, onChange }: FilterTagsProps) {
    return (<div className={styles["filters"]} role="tablist">
        {options.map(([v, label]) => (
            <button key={v} role="tab" aria-selected={value === v} className={Classname.build(styles["filter"], { [styles["active"]]: value === v })} onClick={() => onChange(v)}>[ {label} ]</button>
        ))}
    </div>);
}

export default FilterTags;
